export enum LivePreviewInformationStatus {
  Success = 'success',
  InProgress = 'in-progress',
  Fail = 'fail',
  Cancelled = 'cancelled',
}
